import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronTriangleLeftMedium: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chevron-triangle-left-medium, dropdown, caret"><path d="M14.25 6.75V17.25L8 12L14.25 6.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconChevronTriangleLeftMedium;
